export class Component {
    constructor() { }
}
//# sourceMappingURL=Component.js.map